export const GOOGLE_MAPS_API_KEY = 'AIzaSyAqHJqVulndPDwm01GcmuUcXLOkjtSCY9U';
export const BRIGHTCOVE_ACCOUNT_ID = '1130468768001';
export const ENVIRONMENT_CODE = process.env.CLAYTON_ENVIRONMENT;

//TODO: Note, the GitHub value is probably: ${{ github.run_id }}.${{ github.run_number }}.${{ github.run_attempt }}
// Investigate GitHub Vars? --- might be an ENV var transformation
// TODO After integration
export const RELEASE_VERSION = '#{OctoDeployVersion}';

export const getEnvironmentHost = () => {
  const options = {
    dev: 'https://claytonbuilt-fe.dev.cct-pubweb.com',
    itg: 'https://claytonbuilt-fe.itg.cct-pubweb.com',
    qua: 'https://claytonbuilt-fe.qua.cct-pubweb.com',
    prod: 'https://www.claytonbuilt.com',
    development: 'http://localhost:3000',
    localhost: 'http://localhost:3000',
  };
  return options[ENVIRONMENT_CODE!] || options['prod'];
};

export const getApiUrl = (): string => {
  const options = {
    dev: 'https://api-claytonbuilt.dev.cct-pubweb.com/',
    itg: 'https://api-claytonbuilt.itg.cct-pubweb.com/',
    qua: 'https://api-claytonbuilt.qua.cct-pubweb.com/',
    prod: 'https://api.claytonbuilt.com/',
    localhost: 'http://localhost:3001/',
  };

  return options[ENVIRONMENT_CODE!] || options['prod'];
};
